import { FC } from 'react';
// Mui
import { Box } from '@mui/material';
// Components
import CaseContacts from 'app/components/CaseContacts';

type Props = {
  disabled?: boolean;
}

const ContactsStepContent:FC<Props> = ({
  // Props
  disabled = false
}) => {
  return (
    <Box>
      <CaseContacts disabled={disabled} />
    </Box>
  )
}

export default ContactsStepContent;
